import React, { useEffect, useState } from "react";
import "./home.css";
import coin from "../../assets/dailySession/coin.png";
import TaskItem from "../../components/TaskItem/TaskItem";
import { NavLink } from "react-router-dom";
import getFormattedNumber from "../../hooks/getFormattedNumber";
// import walletIcon from "../../assets/walletIcon.svg";
import playBanner from "../../assets/playBanner.png";
import socialBanner from "../../assets/socialBanner.png";
// import pinNetworkBanner from "../../assets/pinNetworkBanner.svg";
import OutsideClickHandler from "react-outside-click-handler";
import xMark from "../../assets/xMark.svg";
import syncIcon from "../../assets/syncIcon.svg";
import tradingCompTg from "./tradingCompTg.png";
// import { shortAddress } from "../../hooks/shortAddress";
// import tooltip from "../../assets/tooltip.svg";
// import { toast } from "react-toastify";
import DailyTaskItem from "../../components/TaskItem/DailyTaskItem";
// import validateEVM from "../../hooks/validateEVM";
// import OrynPopup from "../../components/OrynPopup/OrynPopup";
import { TonConnectButton, useTonAddress } from "@tonconnect/ui-react";
// import WodCampaignPopup from "../../components/OrynPopup/WodCampaignPopup";
import BitgetPopup from "../../components/OrynPopup/BitgetPopup";
// import bitgetHomeBanner from "../../assets/bitgetHomeBanner.png";
// import Slider from "react-slick";
import {motion} from 'motion/react'
import "./motionStyles.css"

const Home = ({
  username,
  tasks,
  userData,
  handleCompleteTask,
  referralPoints,
  postWalletAddress,
  walletAddress,
  error,
  loadingWallet,
  setLoadingWallet,
  connectPopup,
  setConnectPopup,
  dailySession,
  changeWalletPopup,
  setChangeWalletPopup,
}) => {
  // const [inputData, setInputData] = useState("");
  // const [tooltipInfo, setTooltipInfo] = useState(false);
  const [coinTooltip, setCoinTooltip] = useState(false);
  const [orynPopup, setOrynPopup] = useState(true);
  const tonWallet = useTonAddress();

  // const settings = {
  //   className: "center",
  //   infinite: true,
  //   centerPadding: "60px",
  //   slidesToShow: 1,
  //   autoplay: true,
  //   autoplaySpeed: 4000,
  //   speed: 1000,
  // };

  const homeTasks = tasks.filter(
    (item) =>
      item.partner === "world-of-dypians" &&
      item.type !== "buy_wod" &&
      item.type !== "open_chest"
  );
  const dailyOpportunities = tasks.filter(
    (item) => item.partner === "daily-opportunities"
  );
  // const dummyTasks = [
  //   {
  //     type: "discord",
  //     link: "https://x.com/KuCoinCom",
  //     title: "Follow KuCoin on Twitter",
  //     partner: "kucoin",
  //     reward: 1500,
  //     _id: "kucoin"
  //   },
  //   {
  //     type: "telegram",
  //     link: "https://x.com/worldofdypians",
  //     title: "Follow World of Dypians on Twitter",
  //     partner: "world-of-dypians",
  //     reward: 750,
  //     _id: "wod"
  //   },
  //   {
  //     type: "twitter",
  //     link: "https://x.com/worldofdypians",
  //     title: "Connect World of Dypians on Telegram",
  //     partner: "world-of-dypians",
  //     reward: 750,
  //     _id: "wod"
  //   },
  //   {
  //     type: "youtube",
  //     link: "https://x.com/worldofdypians",
  //     title: "Follow World of Dypians on Instagram",
  //     partner: "world-of-dypians",
  //     reward: 750,
  //     _id: "wod"
  //   },
  // ]

  // const checkEVM = () =>{
  //   if(validateEVM(walletAddress) !== "" && dailySession === false){
  //     setConnectPopup(true)
  //   }
  // }

  // const handlePopup = () => {
  //   if (walletAddress) {
  //     toast.error("You have already associated your wallet", {
  //       className: "custom-toast",
  //       progressClassName: "custom-progress",
  //     });
  //   } else {
  //     setConnectPopup(true);
  //   }
  // };

  const handleWalletPost = (wallet) => {
    postWalletAddress(wallet);
  };
  useEffect(() => {
    if (!connectPopup && !dailySession) {
      setOrynPopup(true);
    } else {
      setOrynPopup(false);
    }
    // eslint-disable-next-line
  }, [connectPopup, dailySession]);
  // const orynTask = tasks.filter((item) => {
  //   return item._id === "6798ef096dc12380e59ac706"
  // })

  useEffect(() => {
    if (!dailySession) {
      setOrynPopup(true);
    } else {
      setOrynPopup(false);
    }
    // eslint-disable-next-line
  }, [dailySession]);

  useEffect(() => {
    // checkEVM();
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, [dailySession]);

  return (
    <>
      <div className="container-fluid home-wrapper pt-4 pb-3">
        <div className="d-flex align-items-center justify-content-between w-100">
          <span className="hello-user">Hello, {username}!</span>
          {/* <div
            className="connect-wallet-wrapper px-2 d-flex align-items-center gap-1"
            onClick={handlePopup}
          >
            <img src={walletIcon} height={16} width={16} alt="" />
            <span className="user-total-coins ps-1">
              {walletAddress ? shortAddress(walletAddress) : "Add Wallet"}
            </span>
          </div> */}
          <div className="d-flex align-items-center gap-2">
            {tonWallet !== walletAddress && tonWallet !== "" ? (
              <button
                className="link-wallet-button p-2"
                style={{
                  fontSize: "14px",
                  height: "40px",
                  width: "40px",
                  borderRadius: "50%",
                }}
                onClick={() => setChangeWalletPopup(true)}
              >
                <img src={syncIcon} alt="" width={25} height={25} />
              </button>
            ) : (
              <></>
            )}
            <div className="wallet-button">
              <TonConnectButton />
            </div>
          </div>
        </div>
        <div className="my-progress-wrapper d-flex flex-column gap-2 p-3 mt-3">
          <div className="d-flex w-100 align-items-center justify-content-between">
            <h6 className="my-progress-title mb-0">My Progress</h6>
            <div className="total-coins-wrapper d-flex align-items-center gap-2 p-1">
              <span
                className="user-total-coins ps-1"
                style={{ fontSize: "18px" }}
              >
                {getFormattedNumber(userData.totalPoints, 0)} Coins
              </span>
              <div className="home-coin-wrapper d-flex align-items-center justify-content-center position-relative">
                <img
                  src={coin}
                  width={24}
                  height={24}
                  alt=""
                  onClick={() => setCoinTooltip(true)}
                />
                <OutsideClickHandler
                  onOutsideClick={() => setCoinTooltip(false)}
                >
                  <div
                    className={`coin-tooltip-content-wrapper ${
                      coinTooltip && "coin-tooltip-active"
                    }`}
                  >
                    <span>
                      This precious coin represents your progress! Accumulate
                      coins through various activities, including completing
                      tasks, participating in daily sessions, interacting with
                      the game, and inviting friends. Your coins allow you to
                      unlock rewards, access exclusive in-game features, and
                      participate in upcoming airdrops. Keep collecting and see
                      where your efforts take you!
                    </span>
                  </div>
                </OutsideClickHandler>
              </div>
            </div>
          </div>
          <div className="home-info-grid">
            <div className="home-info-grid-item d-flex flex-column align-items-center gap-1 py-2">
              <span className="home-grid-value ">
                {getFormattedNumber(
                  userData.streakPoints + userData.chestsPoints,
                  0
                )}
              </span>
              <span className="home-grid-info">Game</span>
            </div>
            <div className="home-info-grid-item d-flex flex-column align-items-center gap-1 py-2">
              <span className="home-grid-value">
                {getFormattedNumber(userData.tasksPoints, 0)}
              </span>
              <span className="home-grid-info">Tasks</span>
            </div>
            <div className="home-info-grid-item d-flex flex-column align-items-center gap-1 py-2">
              <span className="home-grid-value">
                {getFormattedNumber(referralPoints, 0)}
              </span>
              <span className="home-grid-info">Invites</span>
            </div>
          </div>
        </div>
        {/* <Slider {...settings}> */}
          <div className="d-flex flex-column mt-3 mb-5 play-banner-wrapper">
            {/* <img
              src={socialBanner}
              style={{ borderRadius: "10px" }}
              alt=""
            /> */}
            
       <div
              className="relative  flex items-center justify-center z-5"
              style={{ height: "fit-content" }}
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.8, y: 30 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="text-center max-w-2xl mx-auto w-100"
              >
                {/* Compact Announcement Card */}
                <motion.div
                  className="rounded-xl p-8 shadow-2xl relative overflow-hidden backdrop-blur-sm py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #5690FF 0%, #8C56FF 100%)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                  }}
                  initial={{ rotateX: 20 }}
                  animate={{ rotateX: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  whileHover={{ scale: 1.02 }}
                >
                  {/* Shimmer sweep effect */}
                  <motion.div
                    className="absolute inset-0 rounded-xl"
                    style={{
                      background:
                        "linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.15) 50%, transparent 70%)",
                    }}
                    animate={{
                      x: ["-100%", "100%"],
                    }}
                    transition={{
                      duration: 3,
                      repeat: Infinity,
                      ease: "linear",
                      repeatDelay: 2,
                    }}
                  />

                  {/* Subtle particle overlay */}
                  <motion.div
                    className="absolute inset-0 opacity-10"
                    animate={{
                      backgroundPosition: ["0% 0%", "100% 100%"],
                    }}
                    transition={{
                      duration: 20,
                      repeat: Infinity,
                      ease: "linear",
                    }}
                    style={{
                      backgroundImage: `radial-gradient(circle, rgba(255, 255, 255, 0.8) 1px, transparent 1px)`,
                      backgroundSize: "25px 25px",
                    }}
                  />

                  {/* Animated gradient orbs */}
                  <motion.div
                    className="absolute top-0 left-0 w-40 h-40 rounded-full blur-3xl opacity-30"
                    style={{
                      background:
                        "radial-gradient(circle, rgba(255, 255, 255, 0.6) 0%, transparent 70%)",
                    }}
                    animate={{
                      x: [0, 100, 0],
                      y: [0, 80, 0],
                      scale: [1, 1.2, 1],
                    }}
                    transition={{
                      duration: 8,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  />
                  <motion.div
                    className="absolute bottom-0 right-0 w-32 h-32 rounded-full blur-3xl opacity-25"
                    style={{
                      background:
                        "radial-gradient(circle, rgba(255, 255, 255, 0.5) 0%, transparent 70%)",
                    }}
                    animate={{
                      x: [0, -80, 0],
                      y: [0, -60, 0],
                      scale: [1, 1.3, 1],
                    }}
                    transition={{
                      duration: 10,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  />

                  {/* Title */}
                  <motion.h3
                    className="text-1xl md:text-2xl font-bold text-white mb-3 relative z-10 drop-shadow-lg"
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3, duration: 0.6 }}
                  >
                    Liquidity Catalyst Campaign
                  </motion.h3>

                  {/* Rewards Container */}
                  <motion.div
                    className="inline-block mb-6 relative z-10"
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.5, duration: 0.6 }}
                  >
                    <motion.div
                      className="px-6 py-3 rounded-full relative overflow-hidden"
                      style={{
                        background: "rgba(255, 255, 255, 0.25)",
                        border: "2px solid rgba(255, 255, 255, 0.5)",
                        backdropFilter: "blur(10px)",
                      }}
                      animate={{
                        boxShadow: [
                          "0 0 20px rgba(255, 255, 255, 0.3)",
                          "0 0 30px rgba(255, 255, 255, 0.5)",
                          "0 0 20px rgba(255, 255, 255, 0.3)",
                        ],
                      }}
                      transition={{
                        duration: 2,
                        repeat: Infinity,
                        ease: "easeInOut",
                      }}
                    >
                      <motion.h5 className="text-2xl md:text-3xl font-bold text-white drop-shadow-lg mb-0">
                        $250,000 Rewards
                      </motion.h5>
                    </motion.div>
                  </motion.div>

                 
            

                  {/* Corner decorations */}
                  <motion.div
                    className="absolute top-3 right-3 w-8 h-8 rounded-full z-10 border-2 border-white/40"
                    animate={{ rotate: 360 }}
                    transition={{
                      duration: 12,
                      repeat: Infinity,
                      ease: "linear",
                    }}
                  />
                  <motion.div
                    className="absolute bottom-3 left-3 w-6 h-6 rounded-full z-10 border-2 border-white/30"
                    animate={{ rotate: -360 }}
                    transition={{
                      duration: 10,
                      repeat: Infinity,
                      ease: "linear",
                    }}
                  />

                  {/* Glow effect */}
                  <motion.div
                    className="absolute top-1/2 left-1/2 w-32 h-32 rounded-full blur-2xl transform -translate-x-1/2 -translate-y-1/2 bg-white/20"
                    animate={{
                      scale: [1, 1.2, 1],
                      opacity: [0.3, 0.5, 0.3],
                    }}
                    transition={{
                      duration: 4,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  />

                  {/* Edge glow */}
                  <motion.div
                    className="absolute inset-0 rounded-xl"
                    style={{
                      boxShadow: "inset 0 0 20px rgba(255, 255, 255, 0.15)",
                    }}
                    animate={{
                      boxShadow: [
                        "inset 0 0 20px rgba(255, 255, 255, 0.15)",
                        "inset 0 0 30px rgba(255, 255, 255, 0.25)",
                        "inset 0 0 20px rgba(255, 255, 255, 0.15)",
                      ],
                    }}
                    transition={{
                      duration: 3,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  />
                </motion.div>
              </motion.div>
            </div>
            <a
              href="https://www.worldofdypians.com/liquidity-catalyst"
              target="_blank"
              rel="noreferrer"
              to={"/play"}
            >
              <button className={`play-button  py-2 px-4`} style={{zIndex: 5}}>Get</button>
            </a>
          </div>
          {/* <div className="d-flex flex-column mt-3 mb-5 play-banner-wrapper">
            <img src={playBanner} style={{ borderRadius: "10px" }} alt="" />
            <NavLink to={"/play"}>
              <button className={`play-button  py-2 px-4`}>Play</button>
            </NavLink>
          </div>
           */}
        {/* </Slider> */}
        {/* <div className="d-flex flex-column mt-3 mb-5 play-banner-wrapper">
          <NavLink to={"/earn/bitget"}>
          <img src={bitgetHomeBanner} style={{ borderRadius: "10px", width: "100%" }} alt="" />
          </NavLink>
        </div> */}
        <div className="d-flex flex-column gap-2 mt-3">
          <h6 className="home-tasks-title mb-0">Earn</h6>
          <div className="home-tasks-container d-flex flex-column gap-2 position-relative mb-4">
            {homeTasks.length > 0 ? (
              homeTasks
                .slice(0, 4)
                .map((task, index) => (
                  <TaskItem
                    item={task}
                    key={index}
                    handleCompleteTask={handleCompleteTask}
                    page={"home"}
                  />
                ))
            ) : dailyOpportunities.length > 0 ? (
              <>
                {dailyOpportunities.slice(0, 4).map((task, index) => (
                  <DailyTaskItem
                    item={task}
                    key={index}
                    handleCompleteTask={handleCompleteTask}
                  />
                ))}
              </>
            ) : (
              <div className="d-flex flex-column gap-2 w-100 align-items-center justify-content-center  flex-column mt-5">
                <h6 className="empty-title">
                  Well done! Don’t forget to play the game or invite friends to
                  earn even more coins!
                </h6>
                <NavLink to={"/friends"}>
                  <button
                    className={`play-button  py-2 px-4 position-relative`}
                  >
                    Invite Friends
                  </button>
                </NavLink>
              </div>
            )}

            {homeTasks.length >= 4 || dailyOpportunities.length >= 4 ? (
              <NavLink to={"/earn"}>
                <button className="show-more-button py-1 px-2">
                  Show more
                </button>
              </NavLink>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      {/* <OutsideClickHandler onOutsideClick={() => setConnectPopup(false)}>
        <div
          className={`connect-popup d-flex flex-column gap-2 align-items-center ${
            connectPopup && "connect-popup-active"
          } p-3`}
        >
          <div className="d-flex w-100 align-items-center justify-content-between">
            <div className="d-flex flex-column gap-1">
            <div className="d-flex align-items-center gap-1">
              <h6
                className="associate-wallet-title mb-0"
                style={{ color: "#4F5F90" }}
              >
                Associate Wallet
              </h6>
              <div className="position-relative d-flex align-items-center justify-content-center">
                <img
                  src={tooltip}
                  width={20}
                  height={20}
                  style={{ cursor: "pointer" }}
                  alt=""
                  onClick={() => setTooltipInfo(true)}
                />
                <OutsideClickHandler
                  onOutsideClick={() => setTooltipInfo(false)}
                >
                  <div
                    className={`wallet-tooltip-content-wrapper ${
                      tooltipInfo && "wallet-tooltip-active"
                    }`}
                  >
                    <span>
                      Associate a wallet to this account for the chance of weekly and
                      future rewards
                    </span>
                    <br />
                    <span>(TON Compatible Wallets Only!)</span>
                    <br />
                    <span style={{ color: "#FF8168" }}>
                      NOTE: The wallet address cannot be changed so please be
                      careful when you associate it
                    </span>
                  </div>
                </OutsideClickHandler>
              </div>
            </div>
            {validateEVM(walletAddress) !== "" &&
              <span style={{ color: "#FF8168" }}>
              You need to change your wallet to a TON compatible wallet address.
            </span>
            }
            </div>
            <img
              src={xMark}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={() => setConnectPopup(false)}
            />
          </div>
          <input
            type="text"
            placeholder="0x1234..."
            value={inputData}
            onChange={(e) => setInputData(e.target.value)}
            className="px-2 associate-wallet-input w-100"
            style={{ border: error !== "" && "1px solid #FF8168" }}
          />
          {error !== "" && <span style={{ color: "#FF8168" }}>{error}</span>}
          <button
            className="submit-wallet-button py-2 px-3"
            disabled={loadingWallet}
            onClick={() => handleWalletPost(inputData)}
          >
            {loadingWallet ? (
              <div
                className="spinner-border spinner-border-sm text-info"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </OutsideClickHandler> */}
      <OutsideClickHandler onOutsideClick={() => setChangeWalletPopup(false)}>
        <div
          className={`connect-popup d-flex flex-column gap-2 align-items-center ${
            changeWalletPopup && "connect-popup-active"
          } p-3`}
        >
          <div className="d-flex w-100 align-items-center justify-content-between">
            <div className="d-flex flex-column gap-1">
              <div className="d-flex align-items-center gap-1">
                <h6
                  className="associate-wallet-title mb-0"
                  style={{ color: "#4F5F90" }}
                >
                  Link Current Wallet
                </h6>
                {/* <div className="position-relative d-flex align-items-center justify-content-center">
                <img
                  src={tooltip}
                  width={20}
                  height={20}
                  style={{ cursor: "pointer" }}
                  alt=""
                  onClick={() => setTooltipInfo(true)}
                />
                <OutsideClickHandler
                  onOutsideClick={() => setTooltipInfo(false)}
                >
                  <div
                    className={`wallet-tooltip-content-wrapper ${
                      tooltipInfo && "wallet-tooltip-active"
                    }`}
                  >
                    <span>
                      Associate a wallet to this account for the chance of weekly and
                      future rewards
                    </span>
                    <br />
                    <span>(TON Compatible Wallets Only!)</span>
                    <br />
                    <span style={{ color: "#FF8168" }}>
                      NOTE: The wallet address cannot be changed so please be
                      careful when you associate it
                    </span>
                  </div>
                </OutsideClickHandler>
              </div> */}
              </div>
              <span className="change-wallet-desc">
                Link the current connected wallet to your account. Available
                rewards will be distributed to the wallet connected to your
                account.
              </span>
              {/* {validateEVM(walletAddress) !== "" &&
              <span style={{ color: "#FF8168" }}>
              You need to change your wallet to a TON compatible wallet address.
            </span>
            } */}
            </div>
            <img
              src={xMark}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={() => setChangeWalletPopup(false)}
            />
          </div>
          {/* <input
            type="text"
            placeholder="0x1234..."
            value={inputData}
            onChange={(e) => setInputData(e.target.value)}
            className="px-2 associate-wallet-input w-100"
            style={{ border: error !== "" && "1px solid #FF8168" }}
          /> */}
          {/* {error !== "" && <span style={{ color: "#FF8168" }}>{error}</span>} */}
          <button
            className="submit-wallet-button py-2 px-3"
            disabled={loadingWallet}
            onClick={() => handleWalletPost(tonWallet)}
          >
            {loadingWallet ? (
              <div
                className="spinner-border spinner-border-sm text-info"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </OutsideClickHandler>
      {/* {orynPopup && (
        <OutsideClickHandler onOutsideClick={() => setOrynPopup(false)}>
          <BitgetPopup setOrynPopup={setOrynPopup} />
        </OutsideClickHandler>
      )} */}
    </>
  );
};

export default Home;
